import * as React from 'react';
import type { SVGProps } from 'react';
const SvgImage2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    {...props}
    // className="mr-[12px]"
  >
    <path
      d="M2.32031 16.8534L7.64137 11.5323C7.85687 11.3168 8.1127 11.1459 8.39426 11.0293C8.67582 10.9126 8.97759 10.8526 9.28235 10.8526C9.58711 10.8526 9.88888 10.9126 10.1704 11.0293C10.452 11.1459 10.7078 11.3168 10.9233 11.5323L16.2444 16.8534M14.6973 15.3063L16.1505 13.853C16.366 13.6375 16.6219 13.4666 16.9034 13.3499C17.185 13.2333 17.4867 13.1733 17.7915 13.1733C18.0963 13.1733 18.398 13.2333 18.6796 13.3499C18.9612 13.4666 19.217 13.6375 19.4325 13.853L22.4329 16.8534M3.86743 20.7212H20.8857C21.2961 20.7212 21.6896 20.5582 21.9797 20.2681C22.2699 19.9779 22.4329 19.5844 22.4329 19.1741V6.79712C22.4329 6.3868 22.2699 5.99328 21.9797 5.70314C21.6896 5.413 21.2961 5.25 20.8857 5.25H3.86743C3.45711 5.25 3.06359 5.413 2.77345 5.70314C2.48331 5.99328 2.32031 6.3868 2.32031 6.79712V19.1741C2.32031 19.5844 2.48331 19.9779 2.77345 20.2681C3.06359 20.5582 3.45711 20.7212 3.86743 20.7212ZM14.6973 9.1178H14.7055V9.12605H14.6973V9.1178ZM15.084 9.1178C15.084 9.22038 15.0433 9.31876 14.9708 9.39129C14.8982 9.46383 14.7998 9.50458 14.6973 9.50458C14.5947 9.50458 14.4963 9.46383 14.4238 9.39129C14.3512 9.31876 14.3105 9.22038 14.3105 9.1178C14.3105 9.01522 14.3512 8.91684 14.4238 8.8443C14.4963 8.77177 14.5947 8.73102 14.6973 8.73102C14.7998 8.73102 14.8982 8.77177 14.9708 8.8443C15.0433 8.91684 15.084 9.01522 15.084 9.1178Z"
      stroke="#9099A5"
      strokeWidth="1.54712"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgImage2;
